<div class="page-header ">
    <div class="flex xl:align-items-center flex-wrap xl:flex-nowrap gap-3">
        <div class="flex-grow-1">
            <app-primeng-breadcrumb></app-primeng-breadcrumb>
        </div>
        <div class="right-container flex flex-wrap xl:flex-nowrap gap-3 justify-content-end"></div>
    </div>
</div>


<div class="page-content mt-2">
    <p-stepper [(value)]="activeStep" [linear]="false">
        <p-step-list>

            <p-step [value]="0" class="flex-auto">
                <ng-template #content let-value="value" let-activateCallback="activateCallback">
                    <p-button [text]="activeStep>=1"
                        (onClick)=" onToggleTab('info', onEditClick);activateCallback('info',onEditClick)">
                        <i-tabler name="building" class="ti-regular ti-lg"></i-tabler>
                        User Info
                    </p-button>
                    <!-- <span [ngClass]="{
                                'bg-primary border-primary': value <= activeStep,
                                'surface-border': value > activeStep
                            }" (click)="value != activeStep ? onToggleTab('info', onEditClick) : null"
                    (keydown)="activateCallback('info',onEditClick)">
                    <i class="ti ti-building"></i> Organization Info
                </span> -->
                </ng-template>
            </p-step>

            <p-step [value]="1">
                <ng-template #content let-value="value" let-activateCallback="activateCallback">

                    <p-button [text]="activeStep!=1" [disabled]="operation == 'new' && activeStep < 1"
                        (onClick)=" onToggleTab('role', onEditClick);activateCallback('role',onEditClick)">
                        <i-tabler name="user-plus" class="ti-regular ti-lg"></i-tabler>
                        Assign Role
                    </p-button>
                    <!-- <span [ngClass]="{
                            'bg-primary border-primary': value <= activeStep,
                            'surface-border': value > activeStep
                        }" (click)="activateCallback('admin',onEditClick); onToggleTab('admin', onEditClick)"
                    (keydown)="activateCallback('admin',onEditClick); onToggleTab('admin', onEditClick)">
                    <i class="ti ti-user-plus"></i> Add Admin
                </span> -->
                </ng-template>
            </p-step>

            <p-step [value]="2" >
                <ng-template #content let-value="value" let-activateCallback="activateCallback">
                <p-button [text]="activeStep!=2"
                    (onClick)="onToggleTab('resources', onEditClick);activateCallback('resources',onEditClick)">
                    <i-tabler name="layout-grid" class="ti-regular ti-lg"></i-tabler>
                    Assign Scope
                </p-button>

            <!-- <span [ngClass]="{
                                'bg-primary border-primary': value <= activeStep,
                                'surface-border': value > activeStep
                            }" (click)="activateCallback('resources',onEditClick );  onToggleTab('resources', onEditClick)"
                    (keydown)="activateCallback('resources', onEditClick ); onToggleTab('resources', onEditClick)">
                    <i class="ti ti-apps"></i> Assign Resources
                </span> -->
            </ng-template>
            </p-step>

        </p-step-list>

        <p-step-panels>
            <p-step-panel [value]="0" ngSkipHydration>
                <ng-template pTemplate="header" let-onClick="onClick" let-index="index">
                    <span (click)="onToggleTab('info', onClick)" (keydown)="onToggleTab('info', onClick)">
                        <i class="ti ti-user"></i> User Info
                    </span>
                </ng-template>
                <ng-template pTemplate="content" let-nextCallback="nextCallback" let-index="index">
                    <form [formGroup]="userForm" autocomplete="off">
                        <div class="grid" *ngIf="userConfig">
                            <ng-container *ngFor="let config of userConfig | keyvalue">
                                <!---firstName-->
                                <ng-container [ngSwitch]="config.key">

                                    <ng-container *ngSwitchCase="'firstName'">
                                        <!-- Edit Mode -->
                                        <ng-container *ngIf="operation !== 'view'">
                                            <div class="form-group col-6 lg:col-4">
                                                <ng-container *ngIf="loader; else firstnameTemplate">
                                                    <app-skeleton id="label-input-items"></app-skeleton>
                                                </ng-container>
                                                <ng-template #firstnameTemplate>
                                                    <label class="mb-1 block" for="firstName">First Name<span
                                                            class="text-red-500">*</span></label>
                                                    <input pInputText type="text" class="w-full"
                                                        (keypress)="onlyAlphabet($event)" maxlength="25"
                                                        formControlName="firstName" placeholder="Enter First Name"
                                                        id="firstName" name="firstName" />
                                                    <small class="text-red-500 block mt-1"
                                                        *ngIf="userForm.get('firstName')?.touched && !userForm.get('firstName')?.value">
                                                        *First Name is required.
                                                    </small>
                                                </ng-template>
                                            </div>
                                        </ng-container>

                                        <!-- View Mode -->
                                        <div class="col-12 lg:col-4" *ngIf="operation === 'view'">
                                            <p-card styleClass="card-border">
                                                @if (loader) {
                                                <app-skeleton id="label-input-items"></app-skeleton>
                                                } @else {
                                                <label class="mb-1 block">First Name<span
                                                        class="text-red-500">*</span></label>
                                                <h3 class="m-0 font-medium">{{ userForm.get('firstName')?.value || 'No first name
                                                    set' }}</h3>
                                                }
                                            </p-card>
                                        </div>
                                    </ng-container>

                                    <!--lastName-->
                                    <ng-container *ngSwitchCase="'lastName'">
                                        <!-- Edit Mode -->
                                        <ng-container *ngIf="operation !== 'view'">
                                            <div class="form-group col-6 lg:col-4">
                                                <ng-container *ngIf="loader; else lastnameTemplate">
                                                    <app-skeleton id="label-input-items"></app-skeleton>
                                                </ng-container>
                                                <ng-template #lastnameTemplate>
                                                    <label class="mb-1 block" for="lastName">Last Name<span
                                                            class="text-red-500">*</span></label>
                                                    <input pInputText type="text" class="w-full"
                                                        (keypress)="onlyAlphabet($event)" maxlength="25"
                                                        formControlName="lastName" placeholder="Enter Last Name"
                                                        id="lastName" name="lastName" />
                                                    <small class="text-red-500 block mt-1"
                                                        *ngIf="userForm.get('lastName')?.touched && !userForm.get('lastName')?.value">
                                                        *Last Name is required.
                                                    </small>
                                                </ng-template>
                                            </div>
                                        </ng-container>

                                        <!-- View Mode -->
                                        <div class="col-12 lg:col-4" *ngIf="operation === 'view'">
                                            <p-card styleClass="card-border">
                                                @if(loader) {
                                                <app-skeleton [id]="'label-input-items'"></app-skeleton>
                                                } @else {
                                                <label class="mb-1 block">Last Name<span
                                                        class="text-red-500">*</span></label>
                                                <h3 class="m-0 font-medium">{{ userForm.get('lastName')?.value || 'No last name set'
                                                    }}</h3>
                                                }
                                            </p-card>
                                        </div>
                                    </ng-container>
                                    <!---userName-->
                                    <ng-container *ngSwitchCase="'username'">
                                        <!-- Edit Mode -->
                                        <ng-container *ngIf="operation !== 'view'">
                                            <div class="form-group col-6 lg:col-4">
                                                <ng-container *ngIf="loader; else usernameTemplate">
                                                    <app-skeleton id="label-input-items"></app-skeleton>
                                                </ng-container>
                                                <ng-template #usernameTemplate>
                                                    <label class="mb-1 block" for="username">User Name<span
                                                            class="text-red-500">*</span></label>
                                                    <input pInputText type="text" class="w-full"
                                                        (keypress)="onlyLowerCaseAlphabet($event)" maxlength="25"
                                                        formControlName="username" (paste)="onUsernamePaste($event)"
                                                        placeholder="Enter User Name" id="username" name="username" />
                                                    <small class="text-red-500 block mt-1"
                                                        *ngIf="userForm.get('username')?.touched && !userForm.get('username')?.value">
                                                        *User Name is required.
                                                    </small>
                                                </ng-template>
                                            </div>
                                        </ng-container>

                                        <!-- View Mode -->
                                        <div class="col-12 lg:col-4" *ngIf="operation === 'view'">
                                            <p-card styleClass="card-border">
                                                @if (loader) {
                                                <app-skeleton id="label-input-items"></app-skeleton>
                                                } @else {
                                                <label class="mb-1 block">User Name<span
                                                        class="text-red-500">*</span></label>
                                                <h3 class="m-0 font-medium">{{ userForm.get('username')?.value || 'No username set'
                                                    }}</h3>
                                                }
                                            </p-card>
                                        </div>
                                    </ng-container>
                                    <!--email-->
                                    <ng-container *ngSwitchCase="'email'">
                                        <ng-container *ngIf="operation !== 'view'">
                                            <div class="form-group col-6 lg:col-4">
                                                <ng-container *ngIf="loader; else emailTemplate">
                                                    <app-skeleton id="label-input-items"></app-skeleton>
                                                </ng-container>
                                                <ng-template #emailTemplate>
                                                    <label class="mb-1 block" for="">Email<span
                                                            class="text-red-500">*</span></label>
                                                    <input pInputText type="text" class="w-full" formControlName="email"
                                                        placeholder="Enter Email" (input)="validateEmail($event)"
                                                        required />
                                                    <div class="validation-messages">
                                                        <small class="text-red-500 block"
                                                            *ngIf="userForm.get('email')?.touched && !userForm.get('email')?.value">*Email
                                                            is required.</small>
                                                        <small class="text-red-500 block"
                                                            *ngIf="userForm.get('email')?.value && !isEmailValid">*Invalid
                                                            Email Format.</small>
                                                        <small class="text-red-500 block"
                                                            *ngIf="userForm.get('email')?.hasError('forbiddenCharacters')">Email
                                                            should not contain percentage (%), or plus (+).</small>
                                                        <small class="text-red-500 block"
                                                            *ngIf="userForm.get('email')?.hasError('leadingOrTrailingSpaces')">
                                                            Email should not contain leading or trailing spaces.
                                                        </small>
                                                        <small class="text-red-500 block"
                                                            *ngIf="userForm.get('email')?.hasError('multipleSpecialCharacters')">
                                                            Email should not contain consecutive underscores (_) or
                                                            hyphens (-).
                                                        </small>
                                                    </div>
                                                </ng-template>
                                            </div>
                                        </ng-container>
                                        <div class="col-12 lg:col-4" *ngIf="operation === 'view'">
                                            <p-card styleClass="card-border">
                                                @if(loader){
                                                <app-skeleton [id]="'label-input-items'"></app-skeleton>
                                                } @else {
                                                <label class="mb-1 block" for="">Email<span
                                                        class="text-red-500">*</span></label>
                                                <h3 class="m-0 font-medium">{{ userForm.get('email')?.value || 'N/A' }}</h3>
                                                }
                                            </p-card>
                                        </div>
                                    </ng-container>
                                    <!--mobileNo-->
                                    <ng-container *ngSwitchCase="'mobileNo'">
                                        <ng-container *ngIf="operation !== 'view'">
                                            <div class="form-group col-6 lg:col-4">


                                                <ng-container *ngIf="loader; else mobileTemplate">
                                                    <app-skeleton id="label-input-items"></app-skeleton>
                                                </ng-container>
                                                <ng-template #mobileTemplate>
                                                    <label class="mb-1 block" for="">Mobile Number<span
                                                            class="text-red-500">*</span></label>
                                                    <app-custom-phone-number [customPhoneForm]="customPhoneForm"
                                                        [requiredErrorMessage]="'*Mobile Number is required.'"
                                                        (countryChange)="onCountryChange($event)"></app-custom-phone-number>
                                                </ng-template>

                                            </div>
                                        </ng-container>
                                        <div class="col-12 lg:col-4" *ngIf="operation === 'view'">
                                            <p-card styleClass="card-border">
                                                @if(loader){
                                                <app-skeleton [id]="'label-input-items'"></app-skeleton>
                                                } @else{
                                                <label class="mb-1 block" for="">Mobile Number<span
                                                        class="text-red-500">*</span></label>
                                            <h3 class="m-0 font-medium">{{customPhoneForm.get('phoneNumber')?.value ?
                                                customPhoneForm.get('country')?.value?.dial_code+" "+
                                                customPhoneForm.get('phoneNumber')?.value : '-'}}</h3>
                                                }
                                            </p-card>
                                        </div>
                                    </ng-container>
                                    <!--status-->
                                    <ng-container *ngSwitchCase="'status'">
                                        <!-- Edit Mode -->
                                        <ng-container *ngIf="operation !== 'view'">
                                            <div class="form-group col-6 lg:col-4">
                                                <ng-container *ngIf="loader; else statusTemplate">
                                                    <app-skeleton id="label-input-items"></app-skeleton>
                                                </ng-container>
                                                <ng-template #statusTemplate>
                                                    <label class="mb-1 block" for="status">Status<span
                                                            class="text-red-500">*</span></label>
                                                    <div class="flex gap-4 ">
                                                        <label class="flex items-center gap-2 mt-2">
                                                            <p-radioButton name="status" value="Active"
                                                                formControlName="status">
                                                            </p-radioButton>
                                                            Active
                                                        </label>
                                                        <label class="flex items-center gap-2 mt-2">
                                                            <p-radioButton name="status" value="Inactive"
                                                                formControlName="status">
                                                            </p-radioButton>
                                                            Inactive
                                                        </label>
                                                    </div>
                                                </ng-template>
                                            </div>
                                        </ng-container>

                                        <!-- View Mode -->
                                        <div class="col-12 lg:col-4" *ngIf="operation === 'view'">
                                            <p-card styleClass="card-border">
                                                @if (loader) {
                                                <app-skeleton id="label-input-items"></app-skeleton>
                                                } @else {
                                                <label class="mb-1 block">Status<span
                                                        class="text-red-500">*</span></label>
                                                <h3 class="m-0 font-medium">{{ userForm.get('status')?.value || 'No status set' }}
                                                </h3>
                                                }
                                            </p-card>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                        </div>
                        <div class="flex justify-content-end gap-3 mt-4">
                            @if(loader){
                            @if(operation == 'view') {
                            <app-skeleton id="form-fields" [size]="{width:'5rem',height:'2rem'}"></app-skeleton>
                            } @else{ @for (i of [1,2]; track i) {
                            <app-skeleton id="form-fields" [size]="{width:'5rem',height:'2rem'}"></app-skeleton>
                            }
                            }
                            } @else{
                            <p-button type="button" severity="secondary" [label]="addUserConfig.addUser.cancelBtn.title ||
                constants.addUser.cancelBtn.title" (onClick)="navigateToUsers()" />
                            <p-button type="submit" *ngIf="operation == 'new'"
                                [disabled]="userForm.invalid || !isEmailValid || customPhoneForm.invalid || loader"
                                (onClick)="handleAdd()" [label]="addUserConfig.addUser.addBtn.title ||
                    constants.addUser.addBtn.title" />
                            <p-button type="submit" *ngIf="operation == 'edit'"
                                [disabled]="isElementDisabled('user') || customPhoneForm.invalid || loader || !isEmailValid || isAddUpdateButtonClicked"
                                (onClick)="handleUpdate()" label="Update" />
                            }
                        </div>

                    </form>
                </ng-template>



            </p-step-panel>

            <p-step-panel [value]="1" ngSkipHydration>
                <ng-template pTemplate="header" let-onClick="onClick" let-index="index">
                    <span (click)="onToggleTab('role', onClick)" (keydown)="onToggleTab('role', onClick)">
                        <i class="ti ti-user"></i> Assign Role
                    </span>
                </ng-template>
                <ng-template pTemplate="content" let-prevCallback="prevCallback" let-nextCallback="nextCallback"
                    let-index="index">
                    <form [formGroup]="roleForm" autocomplete="off">
                        <div class="grid align-items-end">
                            <div class="col-12 lg:col-6 form-group gap-1">

                                <ng-container *ngIf="loader; else roleDropdownTemplate">
                                    <app-skeleton id="label-input-items"
                                        [size]="{ width: '25rem', type: 'input' }"></app-skeleton>
                                </ng-container>

                                <ng-template #roleDropdownTemplate>
                                    <div class="col-12 lg:col-6 form-group">
                                        <div class="flex flex-column gap-1">

                                            <label for="" class="label">Role</label>
                                            <!-- formControlName="newRole" -->
                                            <p-select class="w-full" [options]="groupedRoles" optionLabel="roleName"
                                                optionValue="roleId" optionGroupLabel="applicationName"
                                                optionGroupChildren="roles" [group]="true" placeholder="Select Role"
                                                appendTo="body" [filter]="true" filterBy="roleName"
                                                formControlName="newRole">

                                                <!-- Template for grouped item -->
                                                <ng-template pTemplate="item" let-option>
                                                    <div class="flex flex-col">
                                                        <span>{{ option.roleName }}</span>
                                                        <!-- <small class="text-gray-500">{{ option.applicationName
                                                            }}</small> -->
                                                    </div>
                                                </ng-template>

                                                <!-- Template for selected item -->
                                                <ng-template pTemplate="selectedItem" let-option>
                                                    <span>{{ option?.roleName }}</span>
                                                </ng-template>

                                                <!-- Template for group label -->
                                                <ng-template pTemplate="group" let-group>
                                                    <div class="p-dropdown-header">{{ group.applicationName }}</div>
                                                </ng-template>
                                            </p-select>



                                        </div>
                                    </div>

                                    <div class="form-group col-fixed">
                                        <p-button *ngIf="operation !== 'view' && roleForm.get('newRole')?.value"
                                            (onClick)="addRole()" label="Add Role">
                                        </p-button>
                                    </div>
                                </ng-template>
                            </div>
                        </div>

                        <div class="grid mt-3">
                            @if (loader) {
                            <div class="flex gap-4">
                                @for (i of [1, 2, 3]; track i) {
                                <app-skeleton id="form-fields"
                                    [size]="{ width: '25rem', height: '3rem' }"></app-skeleton>
                                }
                            </div>
                            } @else {
                            <ng-container formArrayName="scope">
                                <div class="col-6 xl:col-4"
                                    *ngFor="let rolescope of scopeArray.controls; let i = index">
                                    <ng-container [formGroupName]="i">
                                        <p-card styleClass="card-border h-full">
                                            <div class="flex gap-3">
                                                <h3 class="m-0 flex-1 font-medium">{{ getRoleName(i) }}</h3>
                                                <p-button (onClick)="removeScope(i)"
                                                    [disabled]="operation === 'view' || getRoleName(i) === customerAdministrator"
                                                    severity="danger" icon="ti ti-trash">
                                                    <i-tabler name="trash" class="ti-regular ti-lg"></i-tabler>
                                                </p-button>
                                            </div>
                                        </p-card>
                                    </ng-container>
                                </div>
                            </ng-container>
                            }
                        </div>

                        <div class="flex justify-content-end gap-3 mt-4">
                            @if (loader) {
                            @if (operation === 'view') {
                            <app-skeleton id="form-fields" [size]="{ width: '5rem', height: '2rem' }"></app-skeleton>
                            } @else {
                            @for (i of [1, 2]; track i) {
                            <app-skeleton id="form-fields" [size]="{ width: '5rem', height: '2rem' }"></app-skeleton>
                            }
                            }
                            } @else {
                            <p-button type="button" (onClick)="navigateToUsers()" severity="secondary" label="Cancel">
                            </p-button>
                            @if (operation !== 'view') {
                            <p-button type="submit" [disabled]="roleForm.invalid || loader"
                                (onClick)="operation === 'edit' ? handleUpdate() : handleAdd()"
                                [label]="operation === 'edit' ? 'Update' : 'Add'">
                            </p-button>
                            }
                            }
                        </div>

                        <!-- <div class="flex justify-content-end gap-2 mt-3">
                        @if (loader) {
                        @if (operation == 'view') {
                        <app-skeleton id="form-fields" [size]="{ width: '5rem', height: '2rem' }"></app-skeleton>
                        } @else {
                        @for (i of [1, 2]; track i) {
                        <app-skeleton id="form-fields" [size]="{ width: '5rem', height: '2rem' }"></app-skeleton>
                        }
                        }
                        } @else {
                        <p-button type="button" severity="secondary" (onClick)="navigateToUsers()" label="Cancel" />
                        <p-button type="submit" *ngIf="operation !== 'view'" (onClick)="navigateToUsers()" [disabled]="loader"
                        [label]="operation == 'edit' ? 'Update' : 'Continue'" />

                        }
                    </div> -->
                    </form>
                </ng-template>

            </p-step-panel>

            <p-step-panel [value] = "2">
            <ng-template pTemplate="header" let-onClick="onClick" let-index="index">
                <span (click)="onToggleTab('scope',onClick)" (keydown)="onToggleTab('scope',onClick)">
                    <i class="ti ti-user"></i>Assign Scope
                </span>
            </ng-template>
            <ng-template pTemplate="content" let-prevCallback="prevCallback" let-index="index">
                <form [formGroup]="roleForm" autocomplete="off">
                    <div class="grid">
                        @if(loader){
                        <div class="gap-3">

                            <app-skeleton id="form-fields" [size]="{width: '20rem', height: '3rem'}"></app-skeleton>
                            <app-skeleton id="form-fields" [size]="{width: '20rem', height: '1.5rem'}"></app-skeleton>
                            <app-skeleton id="form-fields" [size]="{width: '6rem', height: '1rem'}"></app-skeleton>

                            <div class="flex gap-4 mt-4">
                                @for(i of [1,2,3];track i){
                                <app-skeleton [id]="'label-input-items'"
                                    [size]="{width:'25rem',type:'input'}"></app-skeleton>
                                }
                            </div>
                            <div class="gap-3 mt-4">
                                <app-skeleton id="form-fields"
                                    [size]="{width: '20rem', height: '1.5rem'}"></app-skeleton>
                            </div>
                            <div class="gap-3 mt-4">
                                <app-skeleton id="form-fields" [size]="{width: '6rem', height: '1rem'}"></app-skeleton>
                                <app-skeleton [id]="'label-input-items'"
                                    [size]="{width:'25rem',type:'input'}"></app-skeleton>
                            </div>
                        </div>

                        } @else{
                        <ng-container formArrayName="scope">
                            <ng-container *ngFor="let rolescope of scopeArray.controls; let i=index">
                                <ng-container [formGroupName]="i">
                                    <div class="col-12">

                                        <h3 class="my-1" *ngIf="!roleRemoved">{{ getRoleName(i)}}</h3>

                                        <ng-container *ngIf="!hasHierarchyFilters(i) && !hasNonHierarchyFilters(i)">

                                            <h6 class="mt-0">(* Selected role doesn't have any scope associated with it)
                                            </h6>

                                        </ng-container>

                                    </div>

                                    <ng-container
                                        *ngIf="!isObjectEmpty(filterOptionsBasedOnRole[getRoleIdFromScopeArray(i)])">
                                        <ng-container *ngIf="hasHierarchyFilters(i)">
                                            <div class="col-12">
                                                <h5 class="text-black">HIERARCHY</h5>
                                            </div>
                                            <ng-container *ngFor="let filter of getFiltersOfRole(i); let ind = index">
                                                <div class="col-md md:col-5" *ngIf="filter.scopeType === 'HIERARCHY'">
                                                    <div class="form-group m-0">
                                                        <label for="" class="label w-100">{{filter.scopeName}} </label>
                                                        
                                                            <p-multiSelect class="w-full"
                                                                [formControlName]="filter.scopeName"
                                                                [attr.name]="filter.scopeName+'_'+filter.scopeType"
                                                                [options]="filterOptionsBasedOnRole[getRoleIdFromScopeArray(i)!][getScopeId(filter)!]"
                                                                defaultLabel="Please select" optionLabel="label" optionValue="value"
                                                                (onChange)="scopeSelectedHierachy(i, filter)"
                                                                [disabled]="filter['scopeName'] === 'CUSTOMER_TIER'">
                                                            </p-multiSelect>
                                        
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </ng-container>

                                        <ng-container *ngIf="hasNonHierarchyFilters(i)">
                                            <div class="col-12">
                                                <h6 class="text-black my-2">NON_HIERARCHY</h6>
                                            </div>
                                            <ng-container *ngFor="let filter of getFiltersOfRole(i); let ind = index">
                                                <div class="col-md md:col-4"
                                                    *ngIf="filter.scopeType === 'NON_HIERARCHY'">
                                                    <div class="form-group m-0">
                                                        <label for="" class="label w-100">{{filter.scopeName}} </label>
                                                        <p-multiSelect styleClass="w-full"
                                                            [formControlName]="filter.scopeName"
                                                            [options]="filterOptionsBasedOnRole[getRoleIdFromScopeArray(i)][getScopeId(filter)!]"
                                                            optionLabel="label" optionValue="value"
                                                            display="chip"
                                                            (onChange)="onNonHierarchyScopeChange($event,i, ind)"
                                                            [filter]="true">
                                                            <ng-template pTemplate="selectedItems" let-selectedItems>
                                                                <div class="flex gap-2">
                                                                    <ng-container *ngIf="selectedItems?.length > 0">
                                                                        <ng-container
                                                                            *ngFor="let item of selectedItems  | slice:0:2">
                                                                            <p-chip [label]="$any(item)?.label"
                                                                                [removable]="true"
                                                                                (onRemove)="onNonHierarchyScopeChange(selectedItems,i, ind);setData($event,item,i,filter.scopeName)"></p-chip>
                                                                        </ng-container>

                                                                        <ng-container *ngIf="selectedItems.length > 2">
                                                                            <p-chip
                                                                                [label]="'+' + (selectedItems?.length - 2)"></p-chip>
                                                                        </ng-container>
                                                                    </ng-container>
                                                                    <div class="p-placeholder"
                                                                        *ngIf=" !selectedItems ||selectedItems?.length === 0">
                                                                    </div>
                                                                </div>
                                                            </ng-template>
                                                            <ng-template pTemplate="selectedItems" let-selectedItems>
                                                                <div class="flex gap-2">
                                                                    <ng-container *ngIf="selectedItems?.length > 0">
                                                                        <ng-container
                                                                            *ngFor="let item of selectedItems  | slice:0:2">
                                                                            <p-chip [label]="$any(item)?.label"
                                                                                [removable]="true"
                                                                                (onRemove)="onNonHierarchyScopeChange(selectedItems,i, ind);setData($event,item,i,filter.scopeName)"></p-chip>
                                                                        </ng-container>
                                                                        <ng-container *ngIf="selectedItems.length > 2">
                                                                            <p-chip
                                                                                [label]="'+' + (selectedItems?.length - 2)"></p-chip>
                                                                        </ng-container>
                                                                    </ng-container>
                                                                    <div class="p-placeholder"
                                                                        *ngIf=" !selectedItems ||selectedItems?.length === 0">
                                                                    </div>
                                                                </div>
                                                            </ng-template>
                                                        </p-multiSelect>
                                                        
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                        }
                    </div>
                    <div class="flex justify-content-end gap-3 mt-4">
                        @if(loader){
                        @if(operation == 'view'){
                            <app-skeleton id="form-fields" [size]="{width:'5rem',height:'2rem'}"></app-skeleton>
                        } @else{
                            @for (i of [1,2]; track i) {
                                <app-skeleton id="form-fields" [size]="{width:'5rem',height:'2rem'}"></app-skeleton>
                                }
                            }
                        } @else{
                            <p-button type="button" (onClick)="navigateToUsers()" severity="secondary" label="Cancel" />
                            <p-button type="submit" *ngIf="operation !== 'view'" [disabled]="roleForm.invalid || loader"
                                (onClick)="handleUpdate()" label="Update" />
                        }
                    </div>
                </form>
            </ng-template>
        </p-step-panel> 

        </p-step-panels>
    </p-stepper>

</div>

<p-toast />